<template>
  <div class="wizard-content">
    <div
      v-if="!isDatapeopleAnywhere"
      class="side-bar"
    >
      <WizardProjectIcon
        v-if="iconUrl"
        :src="iconUrl"
        card
        data-testid="project-icon"
      />
      <WizardGradientSideBar
        v-if="graphic.type === 'gradient'"
        :graphic-path="graphic.assetsPath"
        data-testid="gradient-side-bar"
      />
      <WizardSmileSideBar
        v-else
        data-testid="gradient-smile-bar"
      />
    </div>
    <div :class="['slot-flash-message', { 'full-width': !isDatapeopleAnywhere }]">
      <slot name="flashMessage">
        <WizardFlashMessage border-radius="0px 12px 0px 0px" />
      </slot>
      <div :class="['slot', isDatapeopleAnywhere ? 'pa-6' : 'pa-9']">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import WizardSmileSideBar from '@/components/shared/WizardSmileSideBar.vue';
import WizardGradientSideBar from '@/components/shared/WizardGradientSideBar.vue';
import WizardProjectIcon from '@/components/shared/WizardProjectIcon.vue';
import WizardFlashMessage from './WizardFlashMessage.vue';

export default {
  name: 'WizardContent',
  components: {
    WizardSmileSideBar,
    WizardProjectIcon,
    WizardGradientSideBar,
    WizardFlashMessage,
  },
  props: {
    iconUrl: {
      type: String,
      default: null,
    },
    graphic: {
      type: Object,
      default() {
        return {
          type: 'smiles',
          assetsPath: null,
        };
      },
      validator(value) {
        const hasNecessaryPath = value.type === 'gradient' ? Boolean(value.assetsPath) : true;
        return ['smiles', 'gradient'].includes(value.type) && hasNecessaryPath;
      },
    },
  },
  computed: {
    isDatapeopleAnywhere() {
      return this.$route.params.id === 'datapeople-anywhere' || false;
    },
  },
};
</script>

<style scoped lang="less">
.wizard-content {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  min-height: inherit;
}

.side-bar {
  width: 312px;
  position: relative;
  min-height: inherit;
  display: flex;
  align-self: stretch;
}

.slot-flash-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: inherit;
}

.full-width {
  width: calc(100% - 312px);
}

.slot {
  width: 100%;
  min-height: inherit;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  transition: all .3s ease;
}
</style>
